import { useLayoutEffect, useRef } from 'react'

// #301 — the light that runs around an unread Recent Events row (look and motion: `.unread-light` in index.css).
// A CSS animation starts when its element appears, so rows that appeared at different times would show the
// light at different places. Pinning each turn to the page's clock (startTime 0) makes every unread row show
// it at the same place at the same moment (owner: "same for all rows"). The fade-in is left alone.
// #294 redesign — `variant="critical"` is the same light in red (open critical rows and critical popups).
export function UnreadRowLight({ variant = 'unread' }: { variant?: 'unread' | 'critical' } = {}) {
  const ref = useRef<HTMLSpanElement>(null)
  useLayoutEffect(() => {
    const el = ref.current
    if (!el || typeof el.getAnimations !== 'function') return
    for (const anim of el.getAnimations({ subtree: true })) {
      if ((anim as CSSAnimation).animationName === 'unread-light-spin') anim.startTime = 0
    }
  }, [])
  return <span ref={ref} data-unread-light aria-hidden="true" className={variant === 'critical' ? 'unread-light unread-light--critical' : 'unread-light'} />
}
